import { getPresetDateSelection, getTehranDayKey, type DateRangeSelection } from '@/lib/date'
import type { reportApi } from '@/lib/api/report'

type Source = keyof typeof reportApi
export type ReportViewState = {
  selection: DateRangeSelection
  scrollTop: number
  openSections: string[] | null
}

// One UI snapshot per report, owned by the authenticated layout's lifetime.
export function createReportNavigationState() {
  const reports = new Map<Source, ReportViewState>()
  return {
    get(source: Source, now = Date.now()) {
      let view = reports.get(source)
      if (!view || (view.selection.preset !== 'custom' && getTehranDayKey(view.selection.range.to) !== getTehranDayKey(now))) {
        const preset = view?.selection.preset ?? 'today'
        view = { selection: getPresetDateSelection(preset === 'custom' ? 'today' : preset, now), scrollTop: 0, openSections: null }
        reports.set(source, view)
      }
      return view
    },
    select(source: Source, selection: DateRangeSelection) {
      const view: ReportViewState = { selection, scrollTop: 0, openSections: null }
      reports.set(source, view)
      return view
    },
  }
}
